import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Persistent read-only warning shown to Doctor/Receptionist across every page
// while their clinic's subscription is in its 7-day post-expiry grace window.
// Backend already blocks every write during this state (403) — this banner
// makes that state visible up front instead of surprising the user with error
// toasts on their first click.
export default function GracePeriodBanner() {
  const { user } = useAuth();
  if (user?.clinic_subscription_status !== "GRACE") return null;

  return (
    <div
      data-testid="grace-period-banner"
      className="mb-4 flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800"
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <p>
        <span className="font-semibold">Read-Only Mode:</span> your clinic's subscription has expired and is in its grace
        period. You can still view patients, reports, prescriptions and appointment history, but creating or editing new
        records is disabled. Please contact your Super Admin to renew and restore full access.
      </p>
    </div>
  );
}

export function useIsGracePeriod() {
  const { user } = useAuth();
  return user?.clinic_subscription_status === "GRACE";
}
